
import { LockDec, ValidateDec } from '@/decorators';
import { Component, Vue, Watch } from 'vue-facing-decorator'
import { Action, Getter, Mutation, State } from 'vuex-facing-decorator';

@Component({})
export default class extends Vue {
  /** 微信支付申请单，null 表示还没提交过；authUrl 本身就是二维码图片地址，直接 img 渲染 */
  remoteInfo: any = null;

  pollTimer: any = null;

  /**
   * 提交后要经过「本地 queue 推微信 → 微信返回 sign_url」两步，全在后端异步跑，
   * 前端拿不到同步返回值，只能定时回查，所以判断顺序按终态优先排，别被中间态盖掉。
   */
  get applyState() {
    let info = this.remoteInfo;
    if (!info) {
      return { type: 'none', title: '未申请', desc: '请填写以下信息并提交微信支付申请' };
    }
    if (info.type == 2) {
      return { type: 'fail', title: '提交失败', desc: info.errorMessage || '上次申请未能提交成功，请修改后重新提交' };
    }
    if (info.auditType == 2) {
      return { type: 'fail', title: '申请失败', desc: info.errorMessage || '本次申请未通过，可修改信息后重新提交' };
    }
    if (info.auditType == 1) {
      return { type: 'success', title: '已开通', desc: info.mchId ? `商户号：${info.mchId}` : '微信支付已开通' };
    }
    /** sign_url 在「待账户验证」阶段就返回了，这一屏必须引导扫码，否则申请会一直卡住 */
    if (info.authUrl) {
      return { type: 'verify', title: '待账户验证', desc: '请使用微信扫码完成账户验证，验证通过后才会生成商户号' };
    }
    if (info.type == 0) {
      return { type: 'pending', title: '提交中', desc: '申请已提交，正在向微信推送，请稍候' };
    }
    return { type: 'pending', title: '审核中', desc: '微信正在审核，请耐心等待，结果会自动刷新' };
  }

  /** 后端 submit-audit 只放过 type=2 和 auditType=2，其余情况提交必被拒，这里同步挡住 */
  get readOnly() {
    let info = this.remoteInfo;
    if (!info) return false;
    return !(info.type == 2 || info.auditType == 2);
  }

  get submitText() {
    if (!this.readOnly) return '提交信息';
    return this.remoteInfo?.authUrl ? '待账户验证' : '审核中';
  }

  /** 终态就不用再问了 */
  get needPoll() {
    let info = this.remoteInfo;
    if (!info) return false;
    if (info.type == 2 || info.auditType == 1 || info.auditType == 2) return false;
    return true;
  }

  get businessCategory() {
    if (this.categoryV1) return [this.categoryV1, this.formData.settlement_info.qualification_type]
    return null
  }

  categoryV1 = ''
  set businessCategory(v) {
    if (v) {
      this.categoryV1 = v[0]
      this.formData.settlement_info.settlement_id = `${this.businessHash[v[1]].settlement_rule_info.settlement_rule_id}`
      this.formData.settlement_info.qualification_type = v[1]
    }
  }


  get cityCategory() {
    if (!this.formData.bank_account_info.bank_address_code) return null;
    return [this.formData.bank_account_info.bank_address_code.replace(/[0-9][0-9]00$/, '0000'), this.formData.bank_account_info.bank_address_code]
  }

  set cityCategory(v) {
    this.formData.bank_account_info.bank_address_code = v[1]
  }

  get bankCityList() {
    return this.brachBankList.map((item) => {
      return {
        label: item.name,
        value: item.value,
        children: item.list.map((citem) => {
          return { label: citem.name, value: citem.value }
        })
      }
    })
  }

  get businessList() {
    return this.categoryList.map((item) => {
      return {
        label: item.big_industry_info.big_industry_name,
        value: item.big_industry_info.big_industry_id,
        children: item.industry_category_list.map((citem) => {
          return { label: citem.industry_category_info.category_name, value: citem.industry_category_info.category_name }
        })
      }
    })
  }

  get businessHash() {
    let res: Record<string, any> = {}
    this.categoryList.map((item) => {
      item.industry_category_list.map((citem) => {
        res[citem.industry_category_info.category_name] = citem
      })
    })
    return res;
  }

  async changeSubject(v) {
    if (v == this.formData.subject_info.subject_type) return;
    /** 个体户暂未开放，先挡住；等可以进件了把这一段删掉即可 */
    if (v == 'SUBJECT_TYPE_INDIVIDUAL') {
      return this.$error('个体户暂不支持，敬请期待');
    }
    await this.$confirm("改变主体类型所有信息需从新填写", { title: '操作提示' });
    this.formData.subject_info.subject_type = v;
    /** 经营者个人银行卡只对个体户开放，切回企业要退回对公，否则提交会被微信驳回 */
    if (v != 'SUBJECT_TYPE_INDIVIDUAL') {
      this.formData.bank_account_info.bank_account_type = 'BANK_ACCOUNT_TYPE_CORPORATE';
    }
  }
  /**
   * 证件类型
   */
  contactIdDocType = [
    {
      name: '中国大陆居民-身份证',
      value: 'IDENTIFICATION_TYPE_IDCARD'
    },
  ]

  /*
   主体类型 
   */
  subjectType = [
    {
      name: '企业',
      value: 'SUBJECT_TYPE_ENTERPRISE',
      desc: '适合有限公司等法人组织'
    },
    {
      name: '个体户',
      value: 'SUBJECT_TYPE_INDIVIDUAL',
      desc: '适合个体工商户'
    }
  ]

  get isIndividual() {
    return this.formData.subject_info.subject_type == 'SUBJECT_TYPE_INDIVIDUAL'
  }

  /** 营业执照上的商户名称：企业填企业全称，个体户填执照上的名称 */
  get merchantNameLabel() {
    return this.isIndividual ? '个体户名称' : '企业全称'
  }

  /**
   * 银行卡类型
   * 企业只能对公；个体户可以对公，也可以用经营者本人名下的借记卡
   * */
  get bankAccountType() {
    let list = [
      {
        name: '对公银行账户',
        value: 'BANK_ACCOUNT_TYPE_CORPORATE'
      }
    ]
    if (this.isIndividual) {
      list.push({
        name: '经营者个人银行卡',
        value: 'BANK_ACCOUNT_TYPE_PERSONAL'
      })
    }
    return list
  }

  /** 开户名称：对公是营业执照主体名称，个人卡是经营者姓名，微信要求与银行预留信息完全一致 */
  get bankAccountName() {
    if (this.formData.bank_account_info.bank_account_type == 'BANK_ACCOUNT_TYPE_CORPORATE') {
      return this.formData.subject_info.business_license_info.merchant_name || '请输入企业名称'
    }
    return this.formData.subject_info.identity_info.id_card_info.id_card_name || '请输入经营者姓名'
  }

  /**银行卡列表 */
  bankList = [
    {
      name: '工商银行',
      value: '工商银行'
    },
    {
      name: '交通银行',
      value: '交通银行'
    },
    {
      name: '招商银行',
      value: '招商银行'
    },
    {
      name: '民生银行',
      value: '民生银行'
    },
    {
      name: '中信银行',
      value: '中信银行'
    },
    {
      name: '浦发银行',
      value: '浦发银行'
    },
    {
      name: '兴业银行',
      value: '兴业银行'
    },
    {
      name: '光大银行',
      value: '光大银行'
    },
    {
      name: '广发银行',
      value: '广发银行'
    },
    {
      name: '平安银行',
      value: '平安银行'
    },
    {
      name: '北京银行',
      value: '北京银行'
    },
    {
      name: '华夏银行',
      value: '华夏银行'
    },
    {
      name: '农业银行',
      value: '农业银行'
    },
    {
      name: '建设银行',
      value: '建设银行'
    },
    {
      name: '邮政储蓄银行',
      value: '邮政储蓄银行'
    },
    {
      name: '中国银行',
      value: '中国银行'
    },
    {
      name: '宁波银行',
      value: '宁波银行'
    }
  ]

  uploadLoading = false;

  showData: Record<string, string> = {}

  get postData() {
    return this.formData
  }

  submitLoading = false;

  /** 读完立刻按需排下一次轮询 */
  async getData() {
    let { error, data } = await this.$post("/manager/wechat/pay/audit-view");
    if (error) return;
    this.remoteInfo = data || null;
    this.scheduleNextPoll();
  }

  /** 排队推送时问勤一点，等微信审核可以问慢一点 */
  scheduleNextPoll() {
    this.clearPoll();
    if (!this.needPoll) return;
    let delay = this.remoteInfo?.type == 0 ? 5000 : 30000;
    this.pollTimer = setTimeout(() => this.getData(), delay);
  }

  clearPoll() {
    if (this.pollTimer) {
      clearTimeout(this.pollTimer);
      this.pollTimer = null;
    }
  }

  beforeUnmount() {
    this.clearPoll();
  }

  @LockDec("submitLoading")
  @ValidateDec("form")
  async submit() {
    if (this.readOnly) return this.$error('审核中无法修改');
    await this.$postNotify("/manager/wechat/pay/submit-audit", this.postData);
    this.getData();
  }

  @LockDec("uploadLoading")
  async uploadFiles(fieldKey: string) {
    let files = await this.$chooseFile();
    let fd = new FormData()
    fd.append('file', files[0])
    let { error, data, message } = await this.$upload("/manager/wechat/pay/upload-media", fd);
    if (error) {
      return this.$error(message);
    }
    let formdata = this.formData;
    let arr = fieldKey.split('.');
    arr.map((key, index) => {
      if (index == arr.length - 1) {
        formdata[key] = data.mediaId
      } else {
        formdata = formdata[key]
      }
    })
    this.showData[data.mediaId] = data.path;
  }

  @State((state) => state.store.store)
  store;



  @Action("store/getStore")
  getStore


  formData = {
    subject_info: {
      subject_type: "SUBJECT_TYPE_ENTERPRISE",
      business_license_info: {
        license_copy: "",
        license_number: "",
        merchant_name: "",
        legal_person: "",
        license_address: "",
        period_begin: "",
        period_end: ""
      },
      identity_info: {
        id_doc_type: "IDENTIFICATION_TYPE_IDCARD",
        id_card_info: {
          id_card_copy: "",
          id_card_national: "",
          id_card_name: "",
          id_card_number: "",
          id_card_address: "",
          card_period_begin: "",
          card_period_end: ""
        }
      },
      owner: true
    },
    business_info: {
      merchant_shortname: "",
      service_phone: "",
    },
    settlement_info: {
      settlement_id: "",
      qualification_type: ""
    },
    bank_account_info: {
      bank_account_type: "BANK_ACCOUNT_TYPE_CORPORATE",
      account_name: "",
      account_bank: "",
      bank_address_code: "",
      account_number: ""
    },
    contact_info: {
      contact_type: 'LEGAL',
      contact_name: "",
      mobile_phone: "",
      contact_email: ""
    },
  }

  categoryList = []
  brachBankList = []

  created() {
    this.getCategoryList()
    this.getBankList()
    /** 之前提交过的话，刷新页面要能把二维码找回来，不然那个码就再也看不到了 */
    this.getData()
  }

  async getBankList() {
    let { data } = await this.$get('/manager/wechat/pay/bank-address-list')
    this.brachBankList = data.list
  }
  async getCategoryList() {
    let { error, data } = await this.$get('/manager/wechat/pay/category-list')
    if (error) return;
    this.categoryList = data.list;
  }
}
